module.exports = __webpack_public_path__ + "static/media/32.c4a7b69a.svg";